import styled from 'styled-components';

export const Main = styled.div`
	.header-responsive {
		display: flex;
		justify-content: space-between;
		align-items: center;
		
		.logo-responsive:first-child img {
			height: 50px;
		}
		.logo-responsive:last-child img {
			height: 40px;
			margin-right: 15px;
		}
		.ant-btn.ant-btn-primary {
			background: none;
			border: none;
			box-shadow: none;
		}
		.logo-partner {
			padding-left: 30px;
		}
	}
	.main-header-merchant {
		max-width: 1202px;
		margin: auto;
		background: rgb(230, 231, 233);
		display: flex;
	}
	.flex-header {
		display: flex;
		justify-content: space-between;
	}

	.main-header-path {
		max-width: 1202px;
		margin: auto;
		background: rgb(230, 231, 233);
	}
`;
